<template>
    <div class="preservation-shxx">
         <div v-if="this.formData.cFyzt == 3">
            <Slogan theTitle="复议裁定信息"/>
            <van-cell-group>
                    <van-field
                            v-model="formData.cdjg"
                            clearable
                            readonly
                            label="复议结果"
                            @click="toastJoint(formData.cdjg)"
                    ></van-field>
                    <van-field
                            v-model="formData.cdsj"
                            clearable
                            readonly
                            label="复议裁定日期"
                    ></van-field>
                    <van-field class="fd-van-field-has-btn"
                                readonly
                                label="复议裁定书">
                        <van-button
                            class="fd-van-button-link"
                            slot="button"
                            plain
                            type="info"
                            @click="downloadCDS">{{formData.wsmc}}</van-button>
                    ></van-field>
            </van-cell-group>
        </div>
    </div>
</template>

<script>
    import Slogan from '../../../components/common/slogan'
    import { Toast } from 'vant';
    import {fyjgType,typeSqxwfy} from '../../../filters/index'
    // 公共的文件下载方法
    import {downloadFile} from "@/utils/common";

    export default {
        // 注入
        inject: ['fyid'],
        props: {
           //  案件类型
           ajlx: {
               type: String|Number
           }
        },
        data() {
            return {
                formData: {
                    cBqzt: '',
                    cFyzt: '',
                    cShjg: '',
                    dtShsj: '',
                    cShyj: '',
                    shz: '',
                    shjg: '',

                    thyy:'',

                    cdjg:'',
                    cdsj:'',
                    wsmc:'',
                },
                cds:'',
                isShow: 0,
            }
        },
        components: {
            Slogan
        },
        created() {
            this.getBQSHXX();
        },
        mounted() {

        },
        methods: {
             toastJoint(value){
                Toast(value);
            },
            //获取裁定结果
            getBQSHXX() {
                let ajlx = this.ajlx;
                this.$axios.get('ssbq/api/fy/fycdxx?fyid=' + this.fyid).then(res => {
                    let shxx = res.data;
                    if ("1" != shxx.fyzt) {
                        this.isShow = 1;
                    }
                    // 非诉-行为复议
                    if(ajlx == "12" && shxx.fysx == "2"){
                        this.formData.cdjg = typeSqxwfy(shxx.cdjg);
                    }else{
                        this.formData.cdjg = fyjgType(shxx.cdjg);
                    }
                    this.formData.cFyzt = shxx.fyzt;
                    this.formData.cdsj = shxx.cdsj;
                    this.formData.wsmc = shxx.wsmc;
                    this.cds = shxx.cldz;
                });
            },
            //下载裁定书
            downloadCDS(){
                // 下载文件
                downloadFile('/pages/downloadCds/downloadCds?wsmc='+encodeURI(this.formData.wsmc)+'&cds='+encodeURI(this.cds));
            },
        }
    }
</script>
